import { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import api from 'api/client';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';
import AdminUserAssignmentDialog from './components/AdminUserAssignmentDialog';

const AdminTeamsPage = () => {
  const [orgOptions, setOrgOptions] = useState([]);
  const [assignmentTarget, setAssignmentTarget] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  useEffect(() => {
    const loadOrganizations = async () => {
      try {
        const { data } = await api.get('/api/admin/organizations/');
        const rows = Array.isArray(data) ? data : data?.results || [];
        setOrgOptions(rows.map((row) => ({ value: row.id, label: row.name })));
      } catch {
        setOrgOptions([]);
      }
    };
    loadOrganizations();
  }, []);

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'organization_name', label: 'Organization' },
    { key: 'member_count', label: 'Members' },
    {
      key: 'is_active',
      label: 'Status',
      render: (row) =>
        row.is_active ? (
          <Chip size="small" label="Active" sx={{ bgcolor: 'rgba(22,163,74,0.12)', color: '#166534', fontWeight: 600 }} />
        ) : (
          <Chip size="small" label="Inactive" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: '#991b1b', fontWeight: 600 }} />
        )
    }
  ];

  const fields = [
    { name: 'name', label: 'Name', type: 'text', grid: 6 },
    {
      name: 'organization',
      label: 'Organization',
      type: 'select',
      grid: 6,
      nullable: true,
      options: [{ value: '', label: 'No organization' }, ...orgOptions]
    },
    { name: 'is_active', label: 'Active', type: 'switch', grid: 6, defaultValue: true },
    { name: 'description', label: 'Description', type: 'multiline', grid: 12 }
  ];

  return (
    <>
      <AdminResourceCrudPage
        title="Teams"
        subtitle="Group users into operational teams for ownership and workflows."
        icon={GroupsIcon}
        endpoint="/api/admin/teams/"
        columns={columns}
        fields={fields}
        loadParams={{ refresh: refreshToken }}
        rowActions={[
          {
            label: 'Set Members',
            icon: GroupAddIcon,
            onClick: async (row) => {
              setAssignmentTarget(row);
            }
          }
        ]}
      />
      <AdminUserAssignmentDialog
        open={Boolean(assignmentTarget)}
        endpoint={assignmentTarget ? `/api/admin/teams/${assignmentTarget.id}/members/` : ''}
        title={assignmentTarget ? `Team Members - ${assignmentTarget.name}` : 'Team Members'}
        subtitle="Select users to include in this team."
        roleOptions={[
          { value: 'lead', label: 'Lead' },
          { value: 'member', label: 'Member' }
        ]}
        defaultRole="member"
        onSaved={async () => setRefreshToken((prev) => prev + 1)}
        onClose={() => setAssignmentTarget(null)}
      />
    </>
  );
};

export default AdminTeamsPage;
